import { c as _c } from "react/compiler-runtime";
import React from "react";
import DropPartMarkdown from "./DropPartMarkdown";
import DropListItemContentMedia from "../item/content/media/DropListItemContentMedia";
interface DropPartContentProps {
  readonly mentionedUsers: any[];
  readonly referencedNfts: any[];
  readonly partContent: string | null;
  readonly onQuoteClick: (drop: any) => void;
  readonly partMedias: Array<{
    mimeType: string;
    mediaSrc: string;
  }>;
  readonly currentPartCount: number;
}
const DropPartContent: React.FC<DropPartContentProps> = t0 => {
  const $ = _c(12);
  const {
    mentionedUsers,
    referencedNfts,
    partContent,
    onQuoteClick,
    partMedias,
    currentPartCount
  } = t0;
  let t1;
  if ($[0] !== mentionedUsers || $[1] !== onQuoteClick || $[2] !== partContent || $[3] !== referencedNfts) {
    t1 = <div className="tw-group"><DropPartMarkdown mentionedUsers={mentionedUsers} referencedNfts={referencedNfts} partContent={partContent} onQuoteClick={onQuoteClick} /></div>;
    $[0] = mentionedUsers;
    $[1] = onQuoteClick;
    $[2] = partContent;
    $[3] = referencedNfts;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== currentPartCount || $[6] !== partContent || $[7] !== partMedias) {
    t2 = !!partMedias.length && <div className={`${partContent ? "tw-mt-4" : "tw-mt-1"} tw-space-y-2`}>{partMedias.map((media, i) => <div key={`part-${currentPartCount}-media-${i}-${media.mediaSrc}`} className="tw-h-64"><DropListItemContentMedia media_mime_type={media.mimeType} media_url={media.mediaSrc} /></div>)}</div>;
    $[5] = currentPartCount;
    $[6] = partContent;
    $[7] = partMedias;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className="tw-h-full tw-w-full">{t1}{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default DropPartContent;